import apiHelpers from '@/utils/api'
import { AlrContainer } from '@/models/response/AlrContainer'
import { AxiosPromise } from 'axios'
import { AloPlat } from '@/models/alo/AloPlat'
import { ApiResultCode } from '@/enum/ApiResultCode'
import { CarteDatas } from '@/models/alo/CarteDatas'




export default {
  getAllDatas(): AxiosPromise<AlrContainer<CarteDatas>> {    
    return apiHelpers.apiCall({ 
      url: `/webapi/RoomService/carte`, 
      method: 'GET',
      transformResponse: [function (data:string) {          
        return JSON.parse(data) as AlrContainer<CarteDatas>
      }]
    })
  },
  getCrenaux(): AxiosPromise<AlrContainer<Array<Crenau>>>{
    return apiHelpers.apiCall({ 
      url: `/webapi/RoomService/crenaux`, 
      method: 'GET',
      transformResponse: [function (data:string) {          
        return JSON.parse(data) as AlrContainer<Array<Crenau>>
      }]
    })
  }
}



import { accompagnements } from './mock/accompagnements'
import { allergenes } from './mock/allergenes'
import { bios } from './mock/bios'
import { plats } from './mock/plats'
import { arbos, rootArboIds } from './mock/arbos'
import { sections } from './mock/sections'
import { icons } from './mock/icons'
import { Crenau } from '@/models/alo/Crenau'

/*
apiHelpers.addMocks({
  '/webapi/RoomService/carte': {
    'GET':() => {
      return  {
        resultCode:ApiResultCode.Ok,
        datStr:new Date().toISOString(),
        data: {          
           accompagnements:accompagnements,
           allergenes:allergenes,                      
           plats:plats,
           arbos:arbos,
           rootArbosIds:rootArboIds,
           sections:sections,
           icons:icons,
           configuration:{
             langs:["fr","en"]
           }
        },
        dataTypeName: 'CarteDatas'
      } as AlrContainer<CarteDatas>
    }
  }
})*/